import React, {Fragment }from 'react'
import { Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

import estilos from '../AtencionAClientesFC_36Component.module.css';
import { 
    obtenerFC_36UnidadAlmacenMap, 
    obtenerFC_36UnidadEnvasadoMap, 
    obtenerFC_36UnidadProduccionMap, 
    /*eliminarFC_36AnexoUnidadAlmacen,
    eliminarFC_36AnexoUnidadEnvasado,
    eliminarFC_36AnexoUnidadProduccion,*/
} from '../../../../redux/DucksAtencionACliente/FC_36AtencionAClienteDucks';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function TablaAnexosFC36(props) {
    
    const dispatch = useDispatch()
    const modoRevision = useSelector(store => store.FC_36SolicitudAtencionACliente.modoRevision)
    /*Modal*/
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [parametros, setParametros] = React.useState()
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setParametros(data.parametros)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setParametros()
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <Fragment>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} component="h2">
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-dark' onClick={() => {
                                switch (accion) {
                                    case 'eliminarAnexo':
                                        eliminarAnexo(parametros)
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </Fragment>
        )
    }

    const eliminarAnexoModal = (params) => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de eliminar un anexo, esta acción no se podrá revertir.`,
            accion: 'eliminarAnexo',
            parametros: params
        })
    }

    const eliminarAnexo = async (params) => {
        /*if(modoEdicionBorrador) {
            console.log('Esta en modo borrador')
            switch (props.nombreAnexo) {
                case 'Unidad Almacen':
                    //console.log('Borrando unidad almacen', params.id)
                    await dispatch(eliminarFC_36AnexoUnidadAlmacenBD(params.row.idfc36_anexounidaddealmacen))
                    handleCloseModal()
                    break;
                case 'Unidad Envasado':
                    //console.log('Borrando unidad envasado', params.id)
                    await dispatch(eliminarFC_36AnexoUnidadEnvasadoBD(params.row.idfc36_anexounidaddeenvasado))
                    handleCloseModal()
                    break;
                case 'Unidad Produccion':
                    //console.log('Borrando unidad produccion', params.id)
                    await dispatch(eliminarFC_36AnexoUnidadProduccionBD(params.row.idfc36_anexounidaddeproduccion))
                    handleCloseModal()
                    break;
                default:
                    break;
            }
        }else{
            console.log('No esta en modo borrador')*/
        switch (props.nombreAnexo) {
            case 'Unidad Almacen':
                //console.log('Borrando unidad almacen', params.id)
                await dispatch(eliminarFC_36AnexoUnidadAlmacen(params))
                handleCloseModal()
                break;
            case 'Unidad Envasado':
                //console.log('Borrando unidad envasado', params.id)
                await dispatch(eliminarFC_36AnexoUnidadEnvasado(params))
                handleCloseModal()
                break;
            case 'Unidad Produccion':
                //console.log('Borrando unidad produccion', params.id)
                await dispatch(eliminarFC_36AnexoUnidadProduccion(params))
                handleCloseModal()
                break;
            default:
                break;
        }
        //}


    }

    const editarAnexo = (params) => {
        switch (props.nombreAnexo) {
            case 'Unidad Almacen':
                props.history.push('/fc_36AnexoAlmacen', { idEdit: params.id })
                break;
            case 'Unidad Envasado':
                props.history.push('/fc_36AnexoEnvasado', { idEdit: params.id })
                break;
            case 'Unidad Produccion':
                props.history.push('/fc_36AnexoProduccion', { idEdit: params.id })
                break;
            default:
                break;
        }
    }

    async function  corregirAnexo(params){
        switch (props.nombreAnexo) {
            case 'Unidad Almacen':
                await dispatch(obtenerFC_36UnidadAlmacenMap(params.row.idfc36_anexounidaddealmacen))
                props.history.push('/fc_36AnexoAlmacen', { idEdit: params.id })
                break;
            case 'Unidad Envasado':
                await dispatch(obtenerFC_36UnidadEnvasadoMap(params.row.idfc36_anexounidaddeenvasado))
                props.history.push('/fc_36AnexoEnvasado', { idEdit: params.id })
                break;
            case 'Unidad Produccion':
                await dispatch(obtenerFC_36UnidadProduccionMap(params.row.idfc36_anexounidaddeproduccion))
                props.history.push('/fc_36AnexoProduccion', { idEdit: params.id })
                break;
            default:
                break;
        }
    }
    const columns = [
        { field: 'anexo', headerName: 'Anexo', width: 250 },
        { field: 'alias', headerName: 'Alias', width: 160 },
        {/*
            field: 'accion', headerName: 'Eliminar', width: 120,
            renderCell: (params) => (
                <button onClick={() => {
                    eliminarAnexoModal(params)
                }} className='btn btn-danger btn-sm'>Eliminar</button>
            )
            */},
        //onClick={() => editarAnexo(params)}
        {
            field: 'accionEditar', headerName: 'Revisar', width: 120,
            renderCell: (params) => (
                <button onClick={modoRevision ? () => corregirAnexo(params) : () => editarAnexo(params)} className='btn btn-warning text-light'>Revisar</button>
            )
        }
    ]


    const rows = [];
    const data = props.rows
    if(props.rows){
        if(data.length > 0) {
            data.map(item => {
                if(item.data){
                    item.data['anexo'] = props.nombreAnexo    
                    rows.push(item.data)
                }else {
                    item['anexo'] = props.nombreAnexo    
                    rows.push(item)
                }
            })
        }
    }

    return (
        <div className='row ms-1 mt-5'>
            <Paper elevation={5}>
                <div className='row  mb-2'>
                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.divBorderNaranja}`} >
                        <h6 className='text-center'>Tabla de anexos {props.nombreAnexo}</h6>
                    </div>
                    <div className='container mt-1 ms-1'>
                        <div className="row">
                            <div style={{ height: 200, width: '100%' }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pageSize={10}
                                    rowsPerPageOptions={[10]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Paper>
            {modalComponent()}
        </div>
    )
}

export default withRouter(TablaAnexosFC36)
